module.exports = __webpack_public_path__ + "static/media/zoe.3e778428.png";